import React from "react";
import { Box, TextField, Typography } from "@mui/material";
import PhoneInput from "react-phone-number-input";
import { useForm } from "../context/FormContext";

const myStyle = {
    background: "#6EA3D5",
    padding: "8px",
    borderRadius: "5px",
    color: "#ffffff",
    display: "flex",
    alignItems: "center",
};

const PageTitle = () => (
    <Typography variant="h6" style={myStyle} fontWeight={"bold"}>
        Sender Details
    </Typography>
);

function SenderDetails() {

    const { formData, errors, updateField } = useForm();

    return (
        <React.Fragment>
            
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <PageTitle />
                <TextField
                    required
                    id="sender_name"
                    label={"Sender Name"}
                    value={formData.senderName || ""}
                    onChange={(e) => updateField("senderName", e.target.value)}
                />

                <PhoneInput
                    required
                    placeholder="Enter phone number"
                    value={formData.senderNumber || ""}
                    onChange={(value) => updateField("senderNumber", value)}
                    countryCallingCodeEditable={false}
                    international
                    defaultCountry="ZA"
                    error={errors.senderNumber}
                    className={errors.senderNumber ? "phone-input-error" : ""}
                    style={{
                        border: errors.senderNumber ? '1px solid red' : ''
                    }}
                />
                {errors?.senderNumber && (<div style={{ color: "red",marginBottom:'3px'}}  className="HelperText">{errors?.senderNumber}</div>)}

                <TextField
                    id="sender_email"
                    label="Sender Email"
                    value={formData.senderEmail || ""}
                    onChange={(e) => updateField("senderEmail", e.target.value)}
                    error={errors.senderEmail}
                    helperText={errors.senderEmail}
                    fullWidth
                    required
                />
            </Box>
        </React.Fragment>
    );
}

export default SenderDetails;
